// US Phone Area Codes
import areaCodes from "@utils/forms/areaCodesUS.json";

export const validatePassword = (passwordValue: string) =>
  passwordValue?.length ? passwordValue.length > 7 : false;

export const validateFullname = (firstName: string, lastName: string) => {
  const validFormat = /^[A-Za-z@#$%^&*() !_-]+$/;
  if (!validFormat.test(firstName)) {
    return false;
  }

  if (!firstName || firstName === "") {
    return false;
  }
  if (!lastName || lastName === "") {
    return false;
  }
  return true;
};

export const validateName = (name: string) => {
  const validFormat = /^[A-Za-z@#$%^&*() !_-]+$/;
  if (!validFormat.test(name)) {
    return false;
  }

  if (!name) {
    return false;
  }

  return true;
};

export const validatePhone = (phoneValue: string) => {
  if (!phoneValue) {
    return false;
  }

  if (phoneValue.length < 13) {
    return false;
  }

  // Check correct format.
  const phoneNumberRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
  const matchResult = phoneNumberRegex.test(phoneValue);

  if (!matchResult) {
    return false;
  }

  // Check correct area code.
  const parenthesesRegex = /\(([^)]+)\)/;
  const areaCodeMatch = parenthesesRegex.exec(phoneValue);
  const areaCode = parseInt(areaCodeMatch !== null ? areaCodeMatch[1] : "");

  if (!areaCodes.find((item) => item.NPA === areaCode)) {
    return false;
  }
  return true;
};

export const validateEmail = (email: string) => {
  const emailFormat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (emailFormat.test(email)) {
    return true;
  } else {
    return false;
  }
};

export const isValidDateInput = (dateStr: string): boolean => {
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/;
  if (!regex.test(dateStr)) {
    return false;
  }

  const [month, day, year] = dateStr.split("/").map((num) => parseInt(num, 10));
  const date = new Date(year, month - 1, day);

  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};
